import { Component } from '@angular/core';

@Component({
  selector: 'qm-pagenotfound',
  template:`
    <div class="grid" style="margin: 5rem">
      <div class="col-9">
        <div class="flex flex-column align-items-start gap-5">
            <qm-label [labelMessage]="error" sizeFont="h5" styleFont="medium" styleColor="special"></qm-label>
            <qm-label [labelMessage]="title" sizeFont="h1" styleFont="medium" styleColor="special"></qm-label>
            <qm-label [labelMessage]="detail" sizeFont="h3" styleColor="special" lineHeight="160%"></qm-label>
            <qm-button [labelMessage]="btnHome" routerLink="/home"></qm-button>
        </div>
    </div>
      <div class="col-3">
        <img src="assets/img/404.png">
      </div>
    </div>
  `,
  styleUrls: ['./pagenotfound.component.css']
})
export class PagenotfoundComponent {

  public title: string = "Página não encontrada"
  public error: string = "erro 404"
  public btnHome: string = "Ir para página inicial"
  public detail: string = `A página que você buscou não existe ou está fora do ar.
                          Tente fazer uma busca no menu superior ou acesse nossa página inicial`


}
